import React from 'react';

import colours from 'bz-core-controls/styles/colours';

export interface IProps {
  hideLabel?: boolean;
  inline?: boolean;
  isMarkdown?: boolean;
  label?: string;
}

const Label: React.FC<IProps> = React.memo(({ hideLabel, inline, isMarkdown, label }) => {
  if (!inline) {
    return <label style={{ color: colours.lightBlue, fontSize: 16 }}>{label}</label>;
  }

  if (!hideLabel && (!inline || isMarkdown)) {
    return <label style={{ color: colours.lightBlue, fontSize: 16 }}>{label}</label>;
  }

  return null;
});

Label.displayName = 'Label';

export default Label;
